/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ArchiveRouteImport } from './routes/archive'
import { Route as MealsRouteImport } from './routes/meals'
import { Route as PendingRouteImport } from './routes/pending'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SharedRouteImport } from './routes/shared'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as TrashRouteImport } from './routes/trash'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as LabelsLabelIdRouteImport } from './routes/labels.$labelId'
import { Route as MealMealIdRouteImport } from './routes/meal.$mealId'
import { Route as NotesNoteIdRouteImport } from './routes/notes.$noteId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ArchiveRoute = ArchiveRouteImport.update({
  id: '/archive',
  path: '/archive',
  getParentRoute: () => rootRouteImport,
} as any)
const MealsRoute = MealsRouteImport.update({
  id: '/meals',
  path: '/meals',
  getParentRoute: () => rootRouteImport,
} as any)
const PendingRoute = PendingRouteImport.update({
  id: '/pending',
  path: '/pending',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SharedRoute = SharedRouteImport.update({
  id: '/shared',
  path: '/shared',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const TrashRoute = TrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const LabelsLabelIdRoute = LabelsLabelIdRouteImport.update({
  id: '/labels/$labelId',
  path: '/labels/$labelId',
  getParentRoute: () => rootRouteImport,
} as any)
const MealMealIdRoute = MealMealIdRouteImport.update({
  id: '/meal/$mealId',
  path: '/meal/$mealId',
  getParentRoute: () => rootRouteImport,
} as any)
const NotesNoteIdRoute = NotesNoteIdRouteImport.update({
  id: '/notes/$noteId',
  path: '/notes/$noteId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/archive': typeof ArchiveRoute
  '/meals': typeof MealsRoute
  '/pending': typeof PendingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/shared': typeof SharedRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/trash': typeof TrashRoute
  '/admin/users': typeof AdminUsersRoute
  '/labels/$labelId': typeof LabelsLabelIdRoute
  '/meal/$mealId': typeof MealMealIdRoute
  '/notes/$noteId': typeof NotesNoteIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/archive': typeof ArchiveRoute
  '/meals': typeof MealsRoute
  '/pending': typeof PendingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/shared': typeof SharedRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/trash': typeof TrashRoute
  '/admin/users': typeof AdminUsersRoute
  '/labels/$labelId': typeof LabelsLabelIdRoute
  '/meal/$mealId': typeof MealMealIdRoute
  '/notes/$noteId': typeof NotesNoteIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/archive': typeof ArchiveRoute
  '/meals': typeof MealsRoute
  '/pending': typeof PendingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/shared': typeof SharedRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/trash': typeof TrashRoute
  '/admin/users': typeof AdminUsersRoute
  '/labels/$labelId': typeof LabelsLabelIdRoute
  '/meal/$mealId': typeof MealMealIdRoute
  '/notes/$noteId': typeof NotesNoteIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/archive'
    | '/meals'
    | '/pending'
    | '/reset-password'
    | '/search'
    | '/settings'
    | '/shared'
    | '/sign-in'
    | '/sign-up'
    | '/trash'
    | '/admin/users'
    | '/labels/$labelId'
    | '/meal/$mealId'
    | '/notes/$noteId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/archive'
    | '/meals'
    | '/pending'
    | '/reset-password'
    | '/search'
    | '/settings'
    | '/shared'
    | '/sign-in'
    | '/sign-up'
    | '/trash'
    | '/admin/users'
    | '/labels/$labelId'
    | '/meal/$mealId'
    | '/notes/$noteId'
  id:
    | '__root__'
    | '/'
    | '/archive'
    | '/meals'
    | '/pending'
    | '/reset-password'
    | '/search'
    | '/settings'
    | '/shared'
    | '/sign-in'
    | '/sign-up'
    | '/trash'
    | '/admin/users'
    | '/labels/$labelId'
    | '/meal/$mealId'
    | '/notes/$noteId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ArchiveRoute: typeof ArchiveRoute
  MealsRoute: typeof MealsRoute
  PendingRoute: typeof PendingRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SearchRoute: typeof SearchRoute
  SettingsRoute: typeof SettingsRoute
  SharedRoute: typeof SharedRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  TrashRoute: typeof TrashRoute
  AdminUsersRoute: typeof AdminUsersRoute
  LabelsLabelIdRoute: typeof LabelsLabelIdRoute
  MealMealIdRoute: typeof MealMealIdRoute
  NotesNoteIdRoute: typeof NotesNoteIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/archive': {
      id: '/archive'
      path: '/archive'
      fullPath: '/archive'
      preLoaderRoute: typeof ArchiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meals': {
      id: '/meals'
      path: '/meals'
      fullPath: '/meals'
      preLoaderRoute: typeof MealsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pending': {
      id: '/pending'
      path: '/pending'
      fullPath: '/pending'
      preLoaderRoute: typeof PendingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shared': {
      id: '/shared'
      path: '/shared'
      fullPath: '/shared'
      preLoaderRoute: typeof SharedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trash': {
      id: '/trash'
      path: '/trash'
      fullPath: '/trash'
      preLoaderRoute: typeof TrashRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/labels/$labelId': {
      id: '/labels/$labelId'
      path: '/labels/$labelId'
      fullPath: '/labels/$labelId'
      preLoaderRoute: typeof LabelsLabelIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meal/$mealId': {
      id: '/meal/$mealId'
      path: '/meal/$mealId'
      fullPath: '/meal/$mealId'
      preLoaderRoute: typeof MealMealIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notes/$noteId': {
      id: '/notes/$noteId'
      path: '/notes/$noteId'
      fullPath: '/notes/$noteId'
      preLoaderRoute: typeof NotesNoteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ArchiveRoute: ArchiveRoute,
  MealsRoute: MealsRoute,
  PendingRoute: PendingRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SearchRoute: SearchRoute,
  SettingsRoute: SettingsRoute,
  SharedRoute: SharedRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  TrashRoute: TrashRoute,
  AdminUsersRoute: AdminUsersRoute,
  LabelsLabelIdRoute: LabelsLabelIdRoute,
  MealMealIdRoute: MealMealIdRoute,
  NotesNoteIdRoute: NotesNoteIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
